export const styles = {
  container: {
    width: "100%",
    minHeight: "90vh",
    bgcolor: "#f5f5f5",
    p: 3,
  },
  paper: {
    p: 4,
    bgcolor: "#fff",
  },
  heading: {
    mb: 2,
    fontWeight: 700,
    textTransform: "uppercase",
  },
  buttonsContainer: {
    mt: 4,
    display: "flex",
    gap: 2,
    justifyContent: "flex-end",
  },
};
export const FROMstyles = {
  container: {
    width: "100%",
    minHeight: "100vh",
    bgcolor: "#f5f5f5",
    p: 3,
  },
  paper: {
    p: 4,
    bgcolor: "#fff",
  },
  heading: {
    mb: 4,
    fontWeight: 700,
    textTransform: "uppercase",
  },
  buttonsContainer: {
    mt: 4,
    display: "flex",
    gap: 2,
    justifyContent: "flex-end",
  },
  attenderSection: {
    mt: 2,
    mb: 3,
    p: 2,
    bgcolor: "#f9f9f9",
    borderRadius: 1,
  },
  attenderHeading: {
    mb: 1,
    fontWeight: 600,
  },
  attenderCountField: {
    mb: 3,
    width: "200px",
  },
};
